import React from "react";
import FormsReportsList from "../features/forms/components/FormsReportsList";
import useCurrentAccountStore from "./AccountStore";
import shallow from "zustand/shallow";

const AccountFormsTab = () => {
	// const { account } = useCurrentAccountStore((state) => state, shallow);
	// if (Number(account.saleType) === 5) {
	// 	return (
	// 		<FormsReportsList
	// 			listTitle="Single Account Lease Reports"
	// 			searchable={true}
	// 			listName={"lhphForms"}
	// 		/>
	// 	);
	// } else if (Number(account.saleType) === 6) {
	// 	return (
	// 		<FormsReportsList
	// 			listTitle="Single Account Rental Reports"
	// 			searchable={true}
	// 			listName={"rtoForms"}
	// 		/>
	// 	);
	// } else {
	return (
		<FormsReportsList
			listTitle="Single Account Reports"
			searchable={true}
			listName={"bhphForms"}
		/>
	);
	// }
};

export default AccountFormsTab;
